module.exports = "<div fxLayout fxLayoutAlign=\"space-between center\">\n  <span>{{ message }}</span>\n  <mat-icon color=\"primary\" *ngIf=\"status === 'success'\">check_circle</mat-icon>\n  <mat-icon color=\"warn\" *ngIf=\"status === 'error'\">error</mat-icon>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/user-feedback/snackbar/snackbar.component.html
// module id = ./src/app/modules/user-feedback/snackbar/snackbar.component.html
// module chunks = main